/**
 * Content Diffs — shared constants / helpers.
 */

/**
 * Updated_Recently_Window length. The topic badge and the panel's "last
 * updated" line only render for topics whose `latestChangeAt` falls within
 * this window. Any change older than this is treated as not-recent (badge
 * hidden). Requirement 3.3.
 */
export const UPDATED_RECENTLY_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * Returns true when `isoTimestamp` represents a moment within the past
 * `UPDATED_RECENTLY_WINDOW_MS` relative to `now()`. Invalid or missing
 * timestamps return false so a bad payload hides the badge.
 */
export const isWithinUpdatedRecentlyWindow = (
    isoTimestamp: string | undefined | null,
    now: number = Date.now()
): boolean => {
    if (!isoTimestamp) {
        return false;
    }
    const ts = new Date(isoTimestamp).getTime();
    if (Number.isNaN(ts)) {
        return false;
    }
    // Future timestamps (clock skew / bad data) fall outside the window —
    // the badge should not render "Modified 3 days from now".
    const delta = now - ts;
    return delta >= 0 && delta <= UPDATED_RECENTLY_WINDOW_MS;
};
